




















import Vue, { PropOptions } from 'vue';

export type RequestDemoText = Blok & {
  headline?: string;
  description?: string;
  descriptionStyle?: string;
  listItems?: Blok[];
  hubspotForm?: Blok;
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<RequestDemoText>,
  },
});
